<template>
  <div>
    <header>
      <div class="left">
        <h2>Dashboard</h2>
        <p>Description goes here</p>
      </div>

      <div class="right">
        <a class="main-action">New project</a>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
};
</script>
